var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-space-spinner"},[_c('w-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.delayLoader),expression:"delayLoader"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }